import React, { useState } from "react"

import {
  Box,
  Button,
  Container,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Typography
} from "@material-ui/core"
// Styles
import { Autorenew } from "@material-ui/icons";
import { changeView, useClasses, joinClasses } from "../globals";
import { runInAction } from "mobx";


export const TeamSelect = ({ app, possibleTeams }) => {
  const classes = useClasses()
  const [selected, setSelected] = useState("");
  const [selectedError, setSelectedError] = useState(null);
  const [processing, setProcessing] = useState(null);

  return (
    <>
      <Box
        className={joinClasses(
          classes._Flex,
          classes._FlexDirectionColumn,
          classes._Padding
        )}
      >
        <Box className={classes._Margin}>
          <Typography>You are a member of multiple teams within this session. Which team do you want join now?</Typography>
          <FormControl fullWidth variant="outlined">
            <InputLabel>Team</InputLabel>
            <Select label="Session" variant="outlined" value={selected} onChange={e => setSelected(e.target.value)}>
              {possibleTeams.map(team => {
                return <MenuItem value={team.id}>
                  <Typography>{team.name}</Typography>
                </MenuItem>
              })}
            </Select>
            {selectedError && <FormHelperText error>{selectedError}</FormHelperText>}
          </FormControl>
        </Box>
        <Box className={classes._Margin}>
          <Button
            type="submit"
            color="primary"
            variant="contained"
            fullWidth
            startIcon={
              processing ? (
                <Autorenew className={classes.processingIcon} />
              ) : null
            }
            disabled={processing}
            onClick={() => {
              if (processing) { return; }
              if (!selected) {
                setSelectedError("Select a team to continue");
                return;
              }
              const team = possibleTeams.find(team => team.id === selected);
              runInAction(() => {
                app.team = team;
              });
              setProcessing(true);
            }}
          >
            Join Team
          </Button>
        </Box>
      </Box>
    </>
  )
}

TeamSelect.title = "Team Select";